






































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import FileUpload from 'vue-upload-component'
import Modal from '@/components/common/Modal.vue'
import { AssetsModule } from '@/store/modules/asset'
import { AppModule } from '@/store/modules/app'
import { AssetFile, Rect, isSelectable } from '@/store/modules/asset'
import { AssetUsage } from '@/utils/assetUsage'
import EXIFStatic from 'exif-js'
import { ErrorPayload, ErrorsModule } from '@/store/modules/error'
import EventBus from '@/utils/eventBus'
import { AssetAPIError } from "@/utils/assetAPIErrors";
import { ModelError } from "@/rest";
import i18n from '@/i18n'
import { RailwayModule } from '@/store/modules/railway'

@Component({
  name: 'image-upload',
  components: { FileUpload, Modal }
})
export default class ImageUpload extends Vue {
  private multiple: boolean = true
  private drop: boolean = true
  private modal: boolean = false
  private uploadAuto: boolean = true
  private pendingAssetRefresherToken: any

  get reverseFiles() {
    return AssetsModule.assets.slice().reverse()
  }

  get files() {
    return AssetsModule.assets
  }

  set files(files: AssetFile[]) {
    AssetsModule.SetAssets(files)
  }

  get sessionId() {
    let sessionId = ""
    if (AppModule.session && AppModule.session.sessionId) {
      sessionId = AppModule.session.sessionId
    }
    return sessionId
  }

  onClick(asset: AssetFile) {
    if (isSelectable(asset)) {
      this.$emit('click', asset)
    }
  }

  onCancel(asset: AssetFile, event: any) {
    if (!(this.isSelectable(asset) || this.hasError(asset))) {
      (this.$refs.upload as FileUpload).remove(asset)
    } else {
      if (!AssetsModule.selected) {
        RailwayModule.SetDeletingAsset(true)
      }
      AssetsModule.DeleteAsset(asset)
      event.stopPropagation()
    }
  }

  onLoad(asset: AssetFile, event: Event) {
    if (event.target instanceof Image) {
      let width = event.target.naturalWidth
      let height = event.target.naturalHeight
      AssetsModule.SetRectangle([asset, [width, height]])
    }
  }

  uploadImage(file: AssetFile, upload: FileUpload) {
    let xhr = new XMLHttpRequest()
    const regex = new RegExp("%")
    xhr.open('POST', '/rest/asset/' + this.sessionId + '/RAI/' + file.name.replace(regex, ''))
    return (upload as any).uploadXhr(xhr, file, file.file)
  }

  hasUsage(file: AssetFile): boolean {
    return AssetUsage.hasUsage(file)
  }

  isSelectable(file: AssetFile): boolean {
    return isSelectable(file)
  }

  hasError(file: AssetFile): boolean {
    return !!file.error
  }

  showDelete(file: AssetFile): boolean {
    return !this.hasUsage(file) && (this.isSelectable(file) && !this.hasError(file))
  }

  showDeleteButton(file: AssetFile): boolean {
    return !this.hasUsage(file) || (!this.isSelectable(file) || this.hasError(file))
  }

  getEstimatedProgress(file: AssetFile): number {
    if (file.assetId || !file.active) {
      return 100.0
    }
    const offset = 2500.0 + (Math.sqrt(file.size) * 4.2)
    let progress = Number(file.progress)
    if (progress === 0.0) {
      return 0.0
    }

    let elapsed = 1.0 * (Date.now() - file.started)
    let totalTime = ((file.uploaded < 1) ? file.size / (1.0 * file.speed) : file.uploaded - file.started) + offset
    let estimatedProgress = (elapsed / totalTime) * 100.0

    if (file.estimatedProgress < estimatedProgress) {
      if (estimatedProgress > 100.0) {
        return Math.min(100.0, file.estimatedProgress + (100.0 - file.estimatedProgress) / 20.0)
      } else {
        return estimatedProgress
      }
    } else {
      return file.estimatedProgress
    }
  }

  pendingAssetRefresher() {
    this.files.forEach((asset) => {
      if (!asset.assetId && asset.active) {
        let estimatedProgress = this.getEstimatedProgress(asset)
        if (Math.round(estimatedProgress) > Math.round(asset.estimatedProgress)) {
          AssetsModule.SetEstimatedProgress([asset, estimatedProgress])
        }
      }
    })
  }

  resetImageOrientation(image: File, callback: Function) {
    let self = this
    let img = new Image()
    img.onload = () => {
      //@ts-ignore
      EXIFStatic.getData(img, function () {
        let width = img.width,
          height = img.height,
          canvas = document.createElement('canvas'),
          ctx = canvas.getContext("2d"),
          srcOrientation = EXIFStatic.getTag(img, "Orientation");
        if (ctx != null) {
          canvas.width = width;
          canvas.height = height;
          //new browsers rotate the image automatically, for older ones it has to be rotated, square images wont be rotated
          if (!CSS.supports("image-orientation", "from-image")) {
            if ((srcOrientation > 4 && srcOrientation < 9)) {
              canvas.width = height;
              canvas.height = width;
            }
            switch (srcOrientation) {
              case 2: ctx.transform(-1, 0, 0, 1, width, 0); break;
              case 3: ctx.transform(-1, 0, 0, -1, width, height); break;
              case 4: ctx.transform(1, 0, 0, -1, 0, height); break;
              case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
              case 6: ctx.transform(0, 1, -1, 0, height, 0); break;
              case 7: ctx.transform(0, -1, -1, 0, height, width); break;
              case 8: ctx.transform(0, -1, 1, 0, 0, width); break;
              default: ctx.transform(1, 0, 0, 1, 0, 0);
            }
          }
          if ((canvas.width * canvas.height > 16777216) && navigator.userAgent.match(/(iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/)) {
            let { newWidth, newHeight } = self.limitSize(canvas.width, canvas.height, 16777216)
            canvas.width = newWidth;
            canvas.height = newHeight;
            ctx.drawImage(img, 0, 0);
            canvas.toBlob(blob => callback(URL.createObjectURL(blob)))
          } else {
            ctx.drawImage(img, 0, 0);
            canvas.toBlob(blob => callback(URL.createObjectURL(blob)))
          }
        }
      });
    }

    img.src = URL.createObjectURL(image);
  }

  limitSize(width: number, height: number, maximumPixels: number): ({ newWidth: number, newHeight: number }) {
    const requiredPixels = width * height;
    if (requiredPixels <= maximumPixels) return { newWidth: width, newHeight: height };
    const scalar = Math.sqrt(maximumPixels) / Math.sqrt(requiredPixels);
    return {
      newWidth: Math.floor(width * scalar),
      newHeight: Math.floor(height * scalar),
    };
  }

  inputFilter(newFile: AssetFile, oldFile: AssetFile, prevent: () => void) {
    if (newFile && !oldFile) {
      if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
        return prevent()
      }
      if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
        return prevent()
      }
      if (newFile.type !== 'image/jpeg' && newFile.type !== 'image/png') {
        let error = { key: (newFile.id as string), message: this.$t('file').toString() + newFile.name + this.$t('notJpeg').toString() }
        ErrorsModule.SetError(error)
        return prevent()
      }
      if (newFile.size > 50000000) {
        let error = { key: (newFile.id as string), message: this.$t('selectedImage').toString() + newFile.name + this.$t('tooBig').toString() }
        ErrorsModule.SetError(error)
        return prevent()
      }
    }
    if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
      let url = ''
      let URL = window.URL || (window as any).webkitURL
      if (URL && URL.createObjectURL) {
        this.resetImageOrientation(newFile.file, (blob: any) => {
          url = blob
          window.console.log(blob)
          AssetsModule.SetUrl([newFile.id, url])
          this.$forceUpdate()
        }
        )
        newFile.started = Date.now()
        newFile.uploaded = 0
        newFile.estimatedProgress = 0.0
        newFile.usage = {}
        newFile.pendingUsage = {}
        newFile.rect = [0, 0]
        newFile.selected = false
        newFile.active = true
      }
    }
    if (newFile) {
      if (newFile.error && newFile.response) {
        let error = {
          key: (newFile.id as string), message: i18n.t('selectedImage').toString() + newFile.name + i18n.t('cantBeUploaded').toString()
            + AssetAPIError(newFile.response as ModelError)}
        ErrorsModule.SetError(error)
        this.$nextTick(() => {
          (this.$refs.upload as FileUpload).remove(newFile)
        });
      }
    }
  }

  mounted() {
    EventBus.register('IMAGE_UPLOAD', () => {
      let inputs: HTMLCollection = (this.$refs.upload as any).$el.getElementsByTagName('input')
      if (inputs && inputs.item(0)) {
        (inputs.item(0) as HTMLElement).click()
      }
    })
    let inputs: HTMLCollection = (this.$refs.upload as any).$el.getElementsByTagName('input')
    if (inputs && inputs.item(0)) {
      (inputs.item(0) as HTMLElement).focus()
    }
    this.pendingAssetRefresherToken = setInterval(this.pendingAssetRefresher, 100)
  }

  beforeDestroy() {
    EventBus.unregister('IMAGE_UPLOAD')
    clearInterval(this.pendingAssetRefresherToken)
  }
}
